import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';

import { ServiceProvider } from '../providers/service/service';
import { LoginControl } from '../providers/helpers/login';
import { MessageHelper } from '../providers/helpers/messages';
import { LoginPage } from '../pages/login/login';
import { ProfilePage } from '../pages/profile/profile';
import { UsersPage } from '../pages/users/users';
import { FakeItemsComponent } from '../components/fake-items/fake-items';
import { TurmasPage } from '../pages/turmas/turmas';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { CuponsPage } from '../pages/cupons/cupons';
import { AlunosPage } from '../pages/alunos/alunos';
import { MatriculasPage } from '../pages/matriculas/matriculas';
import { DataPagamentoPage } from '../pages/data-pagamento/data-pagamento';
import { CobrancasPage } from '../pages/cobrancas/cobrancas';
import { AlunosTurmasPage } from '../pages/alunos-turmas/alunos-turmas';
import { ReportFinancialPage } from '../pages/report-financial/report-financial';
import { CobrancasArquivadasPage } from '../pages/cobrancas-arquivadas/cobrancas-arquivadas';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    ProfilePage,
    UsersPage,
    TurmasPage,
    CuponsPage,
    AlunosPage,
    MatriculasPage,
    DataPagamentoPage,
    CobrancasPage,
    FakeItemsComponent,
    AlunosTurmasPage,
    ReportFinancialPage,
    CobrancasArquivadasPage
  ],
  imports: [
    BrowserModule,
    BrMaskerModule,
    IonicModule.forRoot(MyApp, {
      mode: 'md',
      backButtonText: '',
      tabsPlacement: 'top',
      menuType: 'overlay'
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    ProfilePage,
    UsersPage,
    TurmasPage,
    CuponsPage,
    AlunosPage,
    MatriculasPage,
    CobrancasPage,
    DataPagamentoPage,
    AlunosTurmasPage,
    ReportFinancialPage,
    CobrancasArquivadasPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    LoginControl,
    MessageHelper,
    ServiceProvider
  ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts